import Application from "../../Application";
import RequestsPresenter, {
  IRequestsPresenter
} from "../../presenter/request/RequestsPresenter";
import GetRequestsInteractor from "./GetRequestsInteractor";

export default class ShowRequestsInteractor {
  private application: Application;
  private output?: IRequestsPresenter;
  private getRequests: GetRequestsInteractor;

  constructor(application, getRequests) {
    this.application = application;
    this.getRequests = getRequests;
  }

  execute() {
    this.output = RequestsPresenter({
      application: this.application
    });
    this.getRequests.execute().then(this.output.setRequests);

    return this.output;
  }
}
